module.exports = __webpack_public_path__ + "static/media/H_CORE-Logo.d0dafeb0.svg";